export const trapFocus = function (element) {
    const focusableSelectors = `
        a[href]:not([disabled]),
        button:not([disabled]):not([tabindex="-1"]),
        textarea:not([disabled]),
        input:not([disabled]),
        select:not([disabled]),
        [tabindex]:not([tabindex="-1"])
    `;

    const updateFocusable = () => {
        const els = Array.from(
            element.querySelectorAll(focusableSelectors)
        ).filter(el => el.offsetParent !== null);

        return {
            focusableEls: els,
            firstEl: els[0],
            lastEl: els[els.length - 1]
        };
    };

    // Initialise
    let { focusableEls, firstEl, lastEl } = updateFocusable();

    // Trap tab
    element.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;

        // Always refresh before processing the tab event
        ({ focusableEls, firstEl, lastEl } = updateFocusable());

        if (focusableEls.length === 0) return;

        if (e.shiftKey) {
            if (document.activeElement === firstEl) {
                lastEl.focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === lastEl) {
                firstEl.focus();
                e.preventDefault();
            }
        }
    });

    // External reset
    element.addEventListener('focus:reset', () => {
        ({ focusableEls, firstEl, lastEl } = updateFocusable());
    });
};
